import { useState } from 'react'

// Admin credentials (in production, these should be environment variables)
const ADMIN_USERNAME = 'admin'
const ADMIN_PASSWORD = 'basebuilders2024'

export interface AdminUser {
  username: string
  isAdmin: boolean
}

export function useAdminAuth() {
  const [adminUser, setAdminUser] = useState<AdminUser | null>(() => {
    // Check localStorage for existing admin session
    const stored = localStorage.getItem('adminSession')
    if (stored) {
      try {
        return JSON.parse(stored)
      } catch {
        return null
      }
    }
    return null
  })

  const adminSignIn = async (username: string, password: string): Promise<boolean> => {
    // Simulate async auth check
    await new Promise(resolve => setTimeout(resolve, 500))
    
    if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
      const admin = { username, isAdmin: true }
      setAdminUser(admin)
      localStorage.setItem('adminSession', JSON.stringify(admin))
      return true
    }
    return false
  }

  const adminSignOut = () => {
    setAdminUser(null)
    localStorage.removeItem('adminSession')
  }

  return {
    adminUser,
    isAdmin: !!adminUser?.isAdmin,
    adminSignIn,
    adminSignOut
  }
}
